export const isGiftShopDomain = () => {
    return window.location.hostname.startsWith('giftshop');
};

export const getGiftShopUrl = () => {
    const host = window.location.host.replace('www.', '');
    // If already on giftshop, just return root
    if (isGiftShopDomain()) {
        return '/';
    }
    return `${window.location.protocol}//giftshop.${host}`;
};

export const getMainSiteUrl = (path: string = '/') => {
    const host = window.location.host;
    if (isGiftShopDomain()) {
        const mainHost = host.replace('giftshop.', '');
        return `${window.location.protocol}//${mainHost}${path}`;
    }
    return path;
};
